import { useCallback, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks'
import { OpenMapViewParams } from '@user/features/GlobalSearch/ResultItem/typings'
import { useDialogState } from '@user/utils/useDialogState'
import { setMapLinkClickedContactLocation } from '@user/store/map'

import { ENTITY_TYPES } from '@sales-center/common'

export function useHandlers() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [mapViewParams, setMapViewParams] = useState<
    OpenMapViewParams | undefined
  >(undefined)
  const [mapViewDialogOpen, setMapViewDialogOpen] = useState<boolean>(false)

  const [topSearch, setTopSearch] = useState<string>('')

  const open = Boolean(anchorEl)
  const [sideDrawerOpen, setSideDrawerOpen, setSideDrawerClose] =
    useDialogState(false)

  const dispatch = useAppDispatch()

  const handleCloseDialogClick = useCallback(() => {
    setMapViewDialogOpen(false)
  }, [setMapViewDialogOpen])

  const onClose = useCallback(() => {
    setAnchorEl(null)
    setTopSearch('')
  }, [])

  const onOpenFilterDrawer = useCallback(
    (search: string) => {
      setSideDrawerOpen()
      setTopSearch(search)
    },
    [setSideDrawerOpen],
  )

  const onOpen = useCallback(
    (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget),
    [],
  )

  const openMapViewDialog = useCallback(
    (mapViewParams: OpenMapViewParams) => {
      dispatch(
        setMapLinkClickedContactLocation({
          latitude: mapViewParams.location.lat,
          longitude: mapViewParams.location.lng,
          count: 1,
          entityId: mapViewParams.entityId || 0,
          entityType: mapViewParams.entityType || ENTITY_TYPES.Lead,
          multitenant: false,
          serviceLocationId: mapViewParams.serviceLocationId || 0,
          pinId: `${mapViewParams.entityId}${mapViewParams.serviceLocationId || ''}`,
          entities: [],
        }),
      )

      setMapViewParams(mapViewParams)
      setMapViewDialogOpen(true)

      onClose()
    },
    [onClose, dispatch],
  )

  return {
    anchorEl,
    setAnchorEl,
    mapViewParams,
    setMapViewParams,
    mapViewDialogOpen,
    onOpen,
    setMapViewDialogOpen,
    topSearch,
    setTopSearch,
    handleCloseDialogClick,
    onClose,
    onOpenFilterDrawer,
    open,
    sideDrawerOpen,
    setSideDrawerOpen,
    setSideDrawerClose,
    openMapViewDialog,
  }
}
